<template>
  <div class="container aos-init aos-animate" data-aos="fade-up">
    <div class="row"></div>
    <div class="section-title">
      <div class="row">
        <div class="col-md-6 my-auto">
          <a href="#" id="buscar_compradores"></a>
          <h3 align="center">Lista de Compradores Cadastrados</h3>
        </div>
      </div>
    </div>
    <br />
    <div style="overflow-x: auto">
      <table
        id="comprar"
        class="table table-striped table-hover table-sm tables-custom"
        style="width: 100%"
      >
        <thead>
          <tr>
            <th></th>
            <th>Nome Fantasia</th>
            <th>CNPJ</th>
            <th>Representante</th>
            <th>CPF</th>
            <th>Nascimento</th>
            <th>Telefone</th>
            <th>E-mail</th>
            <th>Município</th>
            <th>Bairro</th>
            <th>Logradouro</th>
            <th>Número</th>
            <th>Data Cadastro</th>
          </tr>
        </thead>
        <tbody
          v-for="comprador in pageOfItems"
          v-bind:key="comprador.usuarioId"
        >
          <tr>
            <td>
              <a
                href="#"
                @click="
                  excluirUsuario(comprador);
                  filtrar();
                "
              >
                Excluir
              </a>
            </td>
            <td>
              <span v-if="!comprador.empresas">-</span>
              <span v-if="comprador.empresas">
                <a
                  href="#"
                  @click="editarUsuario(comprador)"
                  v-b-modal.modal_inserir_usuario
                  >{{ comprador.empresas[0].nomeFantasia }}</a
                >
              </span>
            </td>
            <td>{{ comprador.cnpj }}</td>
            <td>{{ comprador.nome }}</td>
            <td>{{ comprador.cpf }}</td>
            <td>{{ comprador.nascimento | moment("DD/MM/YYYY") }}</td>
            <td>{{ comprador.telefone }}</td>
            <td>{{ comprador.email }}</td>
            <td>
              <span
                v-if="!comprador.empresas && !comprador.empresas[0].municipio"
                >-</span
              >
              <span
                v-if="comprador.empresas && comprador.empresas[0].municipio"
                >{{ comprador.empresas[0].municipio.nome }}</span
              >
            </td>
            <td>{{ comprador.empresas[0].bairro }}</td>
            <td>{{ comprador.empresas[0].logradouro }}</td>
            <td>{{ comprador.empresas[0].numero }}</td>
            <td>
              {{ comprador.data_cadastro_alteracao | moment("DD/MM/YYYY") }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="row">
      <div class="col">
        <jw-pagination
          :items="compradoresObj"
          @changePage="onChangePage"
          :styles="customStyles"
          :labels="customLabels"
          :PageSize="20"
        ></jw-pagination>
      </div>
    </div>
  </div>
</template>
<style>
a {
  cursor: pointer;
}
.pagination {
  justify-content: center;
  flex-wrap: wrap;
}
</style>

<script>
import { mapActions, mapGetters } from "vuex";
import { municipioAPI, usuarioAPI } from "@/modules/home";

const customStyles = {
  ul: {},
  li: {},
  a: {
    color: "grey",
  },
};

const customLabels = {
  first: "<<",
  last: ">>",
  previous: "<",
  next: ">",
};

export default {
  computed: {
    ...mapGetters(["token", "isAdmin", "isAuthenticated"]),
  },
  props: {
    exibeTabelaVender: { type: Boolean, required: false, default: false },
    compradores: { type: Array, required: false },
  },
  data() {
    return {
      ...mapActions(["setLoading"]),
      filtro: null,
      compradorFiltro: {},
      municipios: [],
      compradoresObj: [],
      municipiosSelecionados: [],
      compradoresSelecionados: [],
      pageOfItems: [],
      customStyles,
      customLabels,
    };
  },
  methods: {
    ...mapActions(["setToken", "setUser", "setAdmin", "logout", "setOutros"]),
    editarUsuario(usuario) {
      // eslint-disable-next-line no-undef
      $("#modal_inserir_usuario").modal();
      this.$store.commit("SET_USUARIO", usuario);
    },
    excluirUsuario(usuario) {
      this.setLoading(true);
      usuarioAPI
        .delete(usuario.usuarioId)
        .then((resp) => {
          this.setLoading(false);
          this.$toast("Usuário deletado com sucesso", {
            timeout: 2000,
            hideProgressBar: true,
          });
        })
        .catch((resp) => {
          this.setLoading(false);
          this.$toast.error("Erro ao deletar Usuário", {
            timeout: 2000,
            hideProgressBar: true,
          });
        });
      this.filtrar();
    },
    onChangePage(pageOfItems) {
      // update page of items
      this.pageOfItems = pageOfItems;
    },
    filtrar() {
      this.setLoading(true);
      usuarioAPI
        .compradoresFiltro(this.compradorFiltro)
        .then((resp) => {
          this.setLoading(false);
          this.compradoresObj = resp.data;
          this.pageOfItems = this.compradoresObj.sort(
            this.compradoresObj.data_cadastro_alteracao
          );
        })
        .catch((resp) => {
          this.setLoading(false);
          this.$toast.error("Erro ao filtrar Compradores", {
            timeout: 2000,
            hideProgressBar: true,
          });
        });
    },
    listarMunicipios() {
      municipioAPI
        .list()
        .then((resp) => {
          this.municipios = resp.data;
        })
        .catch((resp) => {
          this.setLoading(false);
        });
    },
  },
  created() {
    this.listarMunicipios();
    this.filtrar();
  },
  watch: {
    compradores: function (val) {
      this.compradoresObj = val;
    },
    municipiosSelecionados(newValues) {
      this.compradorFiltro.municipiosIds = newValues.map(
        (obj) => obj.municipioId
      );
    },
    compradoresSelecionados(newValues) {
      this.compradorFiltro.nomesEmpresas = newValues.map((obj) => obj.nome);
    },
  },
};
</script>
